'use strict';

// TODO Needs to be updated to work like mission/base/MarkerUtil
// Current implementation makes updating style nearly impossible

var _ = require('lodash');

var _sanitize = function(text) {
  return _.escape(text);
};

module.exports = {

  isMarker: function (layer) {
    if (typeof layer === 'string') {
      layer = layer.toLowerCase();
      return layer === 'marker' || layer === 'text';
    } else {
      return layer.type === 'marker' || layer.type === 'text';
    }
  },

  getIcon: function (type, geojson, defaultStyle) {
    var types = {
      text: function () {
        var label = geojson.properties.text;
        var options = _.defaults({
          html: [
            '<div class="content-wrapper">',
            '<span class="content">',
            _sanitize(label),
            '</span>',
            '</div>'
          ].join('')
        }, defaultStyle);

        return L.divIcon(options);
      },

      marker: function () {
        return L.FontMarker.icon(geojson.properties.marker);
      }
    };

    if (!types[type]) {
      throw new Error ('Unknown icon type: ' + type);
    }

    return types[type]();
  },

  getOptions: function (type, icon, geojson, options) {

    options = _.extend({
      clickable: false,
      draggable: false,
      icon: icon,
    }, options || {});

    if(type === 'marker') {
      // Only show the label for markers, for text ones is included in the icon html
      options.label = _sanitize(geojson.properties.text);
    }
    return options;
  },

  getLeafletLayer: function (latlng, options) {
    var marker = L.marker(latlng, options);
    if (options.label) {
      marker = marker.bindLabel(_sanitize(options.label), {
        className: 'sb-map-marker-text',
        // noHide: true // TODO: Determine functionality based on good usability for showing / editing
      });
    }
    return marker;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/annotation/lib/MarkerUtil.js